import { render, staticRenderFns } from "./OilTankCostAdd.vue?vue&type=template&id=2b81cec2&scoped=true"
import script from "./OilTankCostAdd.vue?vue&type=script&lang=js"
export * from "./OilTankCostAdd.vue?vue&type=script&lang=js"
import style0 from "./OilTankCostAdd.vue?vue&type=style&index=0&id=2b81cec2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b81cec2",
  null
  
)

export default component.exports